import { Field } from "components/shared/form";
import InlineBtn from "components/shared/inlineBtn";
import policy from "policies";
import React from "react";

const DriverEducationResources = (props) => {
    const { data, onChange, config, roles } = props;
    const renderField = (fieldConfig, i) => {
        const value = data.resources[i][fieldConfig.inputProps.name];
        const onFieldChange = ({ name, value }) => {
            const newValue = data.resources.map((item, index) => (index === i ? { ...item, [name]: value } : item));
            onChange({ name: "resources", value: newValue });
        };
        return (
            <Field
                {...fieldConfig}
                i={i}
                value={value}
                onChange={onFieldChange}
                disabled={!policy("user", { user: { roles } }).isAdminWithWriteAccess()}
            />
        );
    };

    const addItem = () => {
        const newValue = [...(data.resources || []), { name: "", link: "" }];
        onChange({ name: "resources", value: newValue });
    };

    const removeItem = (i) => {
        const newValue = data.resources.filter((_, index) => index !== i);
        onChange({ name: "resources", value: newValue });
    };

    return (
        <div className="pb-3">
            {(data.resources || []).map((_, i) => (
                <div className="pb-2" key={i}>
                    {renderField(config.resources.config.name, i)}
                    {renderField(config.resources.config.link, i)}
                    {policy("user", { user: { roles } }).isAdminWithWriteAccess() && (
                        <div className="d-flex justify-content-end">
                            <div className="btn btn-sm btn-outline-danger" onClick={removeItem.bind(this, i)}>
                                Удалить
                            </div>
                        </div>
                    )}
                    <hr />
                </div>
            ))}
            {policy("user", { user: { roles } }).isAdminWithWriteAccess() && (
                <InlineBtn value="Добавить" cname="plus" action={addItem} />
            )}
        </div>
    );
};

export default DriverEducationResources;
